import formatMoney from '~/utils/format-money';
import { Text } from 'theme-ui';

const KitSavingsTag = ({ calculatedKitSavings }) => {
  return (
    <Text
      as="p"
      sx={(t) => ({
        color: t.colors.white,
        fontWeight: 400,
        fontSize: '1.2rem',
        height: 'fit-content',
        width: 'fit-content',
        p: '4px 8px',
        lineHeight: '1.56rem',
        background: t.colors.black,
        textTransform: 'uppercase',
      })}
      aria-label={`Save: ${formatMoney(calculatedKitSavings)}USD`}
    >
      You save ${calculatedKitSavings}
    </Text>
  );
};

export default KitSavingsTag;
